import axios from 'axios'

const apiClient = axios.create({
  baseURL: '/desktopmodules/vue/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  async getData(codiceListino, codiceVariante1Corrente, schedaTabId, defaultTabIdIfError, schedaSettings, requestUrl) {
    const postModel = 
      { 
        codiceListino: codiceListino, 
        codiceVariante1Corrente: codiceVariante1Corrente, 
        schedaTabId: schedaTabId, 
        defaultTabIdIfError: defaultTabIdIfError, 
        schedaSettings: schedaSettings,
        requestUrl: requestUrl
      };
    return await apiClient.post('/Scheda/GetData', postModel)
  },
  async getVariantiProdotto(codiceListino, schedaSettings){
    const postModel = { CodiceListino: codiceListino, SchedaSettings: schedaSettings };
    return await apiClient.post(`/Scheda/GetVariantiProdotto`, postModel);
  },
  getProducts() {
    return apiClient.get('/Scheda/Products')
  },
  getProduct(id) {
    return apiClient.get('/Scheda/Product/'+id)
  },
  getVariantiArticoloDisponibilita(codListino, codArticolo){
    const postModel = { codListino: codListino, codArticolo: codArticolo };
    return apiClient.post('/Scheda/VariantiArticoloDisponibilita', postModel)
  },
  getSezionePrezzi(codArticolo, idAzienda, soloCampione){
    const postModel = { codiceArticolo: codArticolo, idAzienda: idAzienda, soloCampione: soloCampione };
    return apiClient.post('/Scheda/SezionePrezzi', postModel)
  },
  getSezioneMagazzini(codiceArticolo, disabilitaControlloDisp){
    const postModel = {CodiceArticolo: codiceArticolo, DisabilitaControlloDisponibilita: disabilitaControlloDisp };
    return apiClient.post(`/Scheda/SezioneMagazzini`, postModel)
  },
  getGenericImagesFullFilePathComplexData(basePathImmagini, imgFileName){
    const postModel = { basePathImmagini: basePathImmagini, imgFileName: imgFileName };
    return apiClient.post('/Scheda/GetGenericImagesFullFilePathComplexData', postModel)
  },
  getGenericImagesFullFilePath(basePathImmagini, imgFileName){
    const postModel = { basePathImmagini: basePathImmagini, imgFileName: imgFileName };
    return apiClient.post('/Scheda/GetGenericImagesFullFilePath', postModel)
  },
  async getGenericImagesFullFilePathAsync(basePathImmagini, imgFileName){
    const postModel = { basePathImmagini: basePathImmagini, imgFileName: imgFileName };
    return await apiClient.post('/Scheda/GetGenericImagesFullFilePath', postModel)
  },
  getColorImageFullFilePath(imgFileName){
    const postModel = { basePathImmagini: '', imgFileName: imgFileName };
    return apiClient.post('/Scheda/GetColorImageFullFilePath', postModel)
  },
  getAllValues_ByCaratteristica(codListino, numCaratteristica){
    return apiClient.get(`/Scheda/GetAllValuesByCaratteristica/${codListino}/${numCaratteristica}`);
  },
  // downloadFilePersonalizzazione(codPers){
  //   const postModel = { codTipoPers: codPers };
  //   return apiClient.post('/Scheda/DownloadFilePersonalizzazione', postModel, { responseType: "blob" });
  // },
  downloadFileFromRelativePath(relativeFilePath, outFileName, contentType){
    const postModel = { relativeFilePath: relativeFilePath, outFileName: outFileName, contentType: contentType };
    return apiClient.post('/Scheda/DownloadFileFromRelativePath', postModel, { responseType: "blob" });
  },
  async downloadPdfSchedaProdotto(requestDto){
    return await apiClient.post('/Scheda/DownloadPdfSchedaProdotto', requestDto, { responseType: "blob" });
  },
  downloadImmaginiProdotto(codListino, codName, listaImmaginiPrincipali, listaImmaginiDettaglio, basePathImmaginiDettaglioZoomHD){
    const postModel = { 
      codListino: codListino, 
      codName: codName,
      listaImmaginiPrincipali: listaImmaginiPrincipali,
      listaImmaginiDettaglio: listaImmaginiDettaglio,
      basePathImmaginiDettaglioZoomHD: basePathImmaginiDettaglioZoomHD 
    };
    return apiClient.post('/Scheda/DownloadImmaginiProdotto', postModel, { responseType: "blob" });
  },
  async downloadPdfPreventivo(requestDto){
    return await apiClient.post('/Scheda/DownloadPdfPreventivo', requestDto, { responseType: "blob" });
  },
  async downloadPdfPreventivoCliente(requestDto){
    return await apiClient.post('/Scheda/DownloadPdfPreventivoCliente', requestDto, { responseType: "blob" });
  },
  getListaVariantiDisponibiliByMagazzino(codMagazzino, codListino, disabilitaControlloDisp){
    const postModel = {CodiceMagazzino: codMagazzino, CodiceListino: codListino, DisabilitaControlloDisponibilita: disabilitaControlloDisp };
    return apiClient.post(`/Scheda/GetListaVariantiDisponibiliByMagazzino`, postModel);
  },
  getDisponibilitaByMagazzino(codListino, codVar1, codMagazzino){
    const postModel = { codiceListino: codListino, codiceVariante1: codVar1, codiceMagazzino: codMagazzino };
    return apiClient.post('/Scheda/GetDisponibilitaByMagazzino', postModel)
  },
  async getServizi(idAzienda, tipoServizio, codiceServizio){
    const postModel = { IdAzienda:idAzienda, TipoServizio: tipoServizio, CodiceServizio:codiceServizio };
    return await apiClient.post('/Scheda/GetServizi', postModel) 
  },
  
  async validateArticolo(requestDto){
    return await apiClient.post('/Carrello/ValidateArticolo', requestDto);
  },
  async validateRows(righe, righePers, sePersonalizzare, idAzienda, seMerceCampione){
    const postModel = { Rows: righe, PersonalizzazioniRows: righePers, SePersonalizzare: sePersonalizzare, IdAzienda: idAzienda, SeMerceCampione: seMerceCampione };
    return await apiClient.post('/Carrello/ValidateRowsInsert', postModel)
  },
  async insertRowsToCart(requestDto){
    return await apiClient.post('/Carrello/InsertRows', requestDto)
  },
  async updateRowsCart(requestDto){
    return await apiClient.post('/Carrello/UpdateRows', requestDto)
  },
  async insertPersRowsToCart(requestDto){
    return await apiClient.post('/Carrello/InsertPersRows', requestDto)
  },
  async getCarrelloByIdAzienda(idAzienda){
    return await apiClient.get(`/Carrello/CarrelloUtenteByIdAzienda/${idAzienda}`);
  },
  insertServiceToCart(servizioInfo, idAzienda){
    const postModel = { ServizioToInsert: servizioInfo, IdAzienda: idAzienda };
    return apiClient.post('/Carrello/InsertServiceToCart', postModel);
  },
  async getDataEvasione(requestDto){
    return await apiClient.post('/Carrello/GetDataEvasioneCarrello', requestDto);
  },
  async getDataEvasioneApplicaCutOff(requestDto){
    return await apiClient.post('/Carrello/GetDataEvasioneApplicaCutOff', requestDto);
  },
  async getPosizioniStampabili(requestDto){
    return await apiClient.post('/Carrello/GetPosizioniStampabili', requestDto);
  },
  async getColoriStampabili(requestDto){
    return await apiClient.post('/Carrello/GetColoriStampabili', requestDto);
  },
  async deleteCartPersRows(requestDto){
    return await apiClient.post('/Carrello/DeletePersRows', requestDto);
  },
  async deleteCartRows(requestDto){
    return await apiClient.post('/Carrello/DeleteRows', requestDto);
  },
  async deleteUploadedLogo(requestDto){
    return await apiClient.post('/Carrello/DeleteUploadedLogo', requestDto);
  },
  cleanCartPendingRows(requestDto){
    return apiClient.post('/Carrello/CleanCartPendingRows', requestDto);
  },
  async getRiepilogoCarrelliAzienda(requestDto){
    return await apiClient.post('/Carrello/GetRiepilogoCarrelliAzienda', requestDto);
  },

  async uploadFileLogo(formData){
    return await apiClient.post('/Carrello/UploadFilePers', formData, 
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getCodiciIva(codiceIva = ""){
    return apiClient.get(`/Checkout/GetCodiciIva/${codiceIva}`);
  },
  getRiepilogoIva(requestDto){
    return apiClient.post('/Checkout/GetRiepilogoIva', requestDto);
  },
  getPagamentiAcquistoServizi(requestDto){
    return apiClient.post('/Checkout/GetPagamentiAcquistoServizi', requestDto);
  },
  getPagamenti(requestDto){
    return apiClient.post('/Checkout/GetPagamenti', requestDto);
  },
  getCodiciPagamentoByTipoPagamento(tipoPagamento){
    return apiClient.get(`/Checkout/GetCodiciPagamentiByTipoPagamento/${tipoPagamento}`);
  },
  getModalitaSpedizione(requestDto){
    return apiClient.post('/Checkout/GetModalitaSpedizione', requestDto);
  },
  getCorrieri(){
    return apiClient.get(`/Checkout/GetCorrieri`);
  },
  async inviaOrdine(inviaOrdineRequestDto){
    return await apiClient.post('/Checkout/InviaOrdine', inviaOrdineRequestDto)
  },

  getDestinazioni(idAzienda){
    return apiClient.get(`/Destinazioni/GetDestinazioni/${idAzienda}`);
  },

  async loggedUser(loggedUserRequestDto) {
    return await apiClient.post('/User/LoggedUser', loggedUserRequestDto);
  },
  loginUser(loginUserRequestDto){
    return apiClient.post('/User/Login', loginUserRequestDto)
  },
  logoutUser(){
    return apiClient.post('/User/Logout')
  },
  accettazionePrivacy(idAzienda){
    return apiClient.get(`/User/AccettazionePrivacy/${idAzienda}`);
  },
  async getCodiceFiscaleById(idAzienda){
    return await apiClient.get(`/User/GetCodiceFiscaleById/${idAzienda}`);
  },
  async updateCodiceFiscaleById(requestDto){
    return await apiClient.put('/User/UpdateCodiceFiscale', requestDto);
  },
  async getDatiFattElettronicaById(idAzienda){
    return await apiClient.get(`/User/GetDatiFattElettronicaById/${idAzienda}`);
  },
  async updateDatiFattElettronicaById(requestDto){
    return await apiClient.put('/User/UpdateDatiFattElettronica', requestDto);
  },
  async getCondizioniVendita(idAzienda){
    return await apiClient.get(`/User/GetCondizioniVendita/${idAzienda}`);
  },
  accettazioneCondizioniVendita(idAzienda){
    return apiClient.get(`/User/AccettazioneCondizioniVendita/${idAzienda}`);
  },

  //PAYPAL
  async generateClientToken(){
    return await apiClient.post('/PayPalCheckout/GenerateClientToken');
  },
  async createOrder(requestDto){
    return await apiClient.post('/PayPalCheckout/CreateOrder', requestDto);
  },
  async capturePayment(requestDto){
    return await apiClient.post('/PayPalCheckout/CapturePayment', requestDto);
  },
  async cancelOrder(requestDto){
    return await apiClient.post('/PayPalCheckout/CancelOrder', requestDto);
  }
}